<div class="main-view">
  <router-outlet></router-outlet>
</div>
<div class="faded-gradient-bg" *ngIf="showFadedBg === true"></div>
<nav *ngIf="!isNewCampaign" class="navbar navbar-expand-md navbar-light fixed-top">
  <div class="navbar-top d-flex">
    <div class="navbar-brand logo flex-fill d-flex justify-content-center">
      <img [src]="logoImage" width="66"/>
    </div>
    <div class="toggle-button" [ngClass]="{'expanded': expandMobileMenu}" (click)="toggleMobileMenu()">
      <span class="navbar-toggler-icon"></span>
    </div>
  </div>
  <div id="mobile-menu" class="collapse navbar-collapse" [ngClass]="{'show': expandMobileMenu}">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" *ngIf="!isDisableHomePage">
        <a class="nav-link" [routerLink]="['/dashboard/home']" [routerLinkActive]="['active']">{{'user.menu.home' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/dashboard/details/overview']" [routerLinkActive]="['active']">{{'user.menu.profile' | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="!isDisableCampaignPage">
        <a class="nav-link" [routerLink]="['/dashboard/campaigns']" [routerLinkActive]="['active']">{{'user.menu.campaigns' | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="!isDisableInboxPage">
        <a class="nav-link" [routerLink]="['/dashboard/inbox']" [routerLinkActive]="['active']">{{'user.menu.inbox' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/dashboard/settings']" [routerLinkActive]="['active']">{{'user.menu.user_settings' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="logout()">{{'user.menu.log_out' | translate}}</a>
      </li>
    </ul>
  </div>
</nav>
<div class="sidebar">
  <ul class="menu">

    <li class="logo">
      <img [src]="logoImage"/>
    </li>

    <li class="dashboard-home" *ngIf="!isDisableHomePage">
      <a class="sidebar-icon" [routerLink]="['/dashboard/home']" [routerLinkActive]="['active']">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 38">
          <defs>
            <clipPath id="5xw3a">
              <path fill="#fff" d="M24 18V0h18v18zm9-4a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"/>
            </clipPath>
          </defs>
          <path fill="#95a0b1" fill-rule="evenodd"
                d="M21.696 3.001a2.235 2.235 0 0 0-3.232 0L1.078 20.403c-.889.921-.555 1.676.737 1.676h3.627v13.365c0 .966.039 1.75 1.785 1.75h8.437V23.79h8.832v13.403h8.857c1.33 0 1.365-.784 1.365-1.75V22.079h3.627c1.292 0 1.626-.755.737-1.676z"/>
          <path fill="#c60c30" d="M33 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"/>
          <path fill="none" stroke="#fff" stroke-miterlimit="50" stroke-width="8"
                d="M33 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10z" clip-path="url(&quot;#5xw3a&quot;)"/>
        </svg>
      </a>
    </li>


    <li class="dashboard-measure">
      <a class="sidebar-icon"
         placement="right" ngbTooltip="{{'info_box.influencer.infl_app_sidebar' | translate}}"
         [routerLink]="['/dashboard/details/insight']" [routerLinkActive]="['active']">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 21">
          <path
            d="M12.29 15.682C13.32 13.895 23.877.283 24.444.609c.567.329-5.945 16.274-6.977 18.062-1.031 1.787-2.653 1.919-4.083 1.094-1.43-.825-2.126-2.296-1.094-4.083zm-9.159 1.74c0 .466.02.932.061 1.383a1.497 1.497 0 0 1-1.356 1.623 1.5 1.5 0 0 1-1.62-1.357 18.55 18.55 0 0 1-.074-1.65c0-9.02 6.566-16.086 14.947-16.086 1.397 0 2.742.2 4.016.568-.714.86-1.447 1.763-2.102 2.582a11.533 11.533 0 0 0-1.914-.161c-6.705 0-11.958 5.754-11.958 13.097zm26.904.005c0 .565-.025 1.13-.076 1.684a1.495 1.495 0 0 1-1.486 1.36c-.046 0-.091-.003-.138-.006a1.494 1.494 0 0 1-1.353-1.624c.043-.466.064-.941.064-1.414 0-3.03-.895-5.786-2.414-7.984.388-.99.829-2.132 1.246-3.254 2.584 2.883 4.157 6.824 4.157 11.238z"
            fill="#95a0b1" fill-rule="evenodd"/>
        </svg>
      </a>
    </li>

    <li class="dashboard-campaign" *ngIf="!isDisableCampaignPage">
      <a class="sidebar-icon"
         placement="right" ngbTooltip="{{'info_box.campaign.sidebar' | translate}}"
         [routerLink]="['/dashboard/campaigns']" [routerLinkActive]="['active']">
        <svg viewBox="0 0 105 111" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M93.228 73.821c-1.748.716-13.504-8.624-21.018-26.235-7.511-17.607-6.567-33.705-4.821-34.42 1.745-.714 13.212 10.552 20.725 28.16 7.511 17.607 6.863 31.78 5.114 32.495m3.365-36.75C86.926 14.42 71.371-2.835 63.5.389c-13.366 5.47 7.963 31.749-57.67 58.62-5.669 2.32-7.106 11.61-4.733 17.163 2.368 5.553 10.122 11.08 15.794 8.759.979-.401 4.583-1.568 4.583-1.568 4.049 5.472 8.286 2.226 9.788 5.703 1.806 4.18 5.735 13.263 7.068 16.355 1.338 3.088 4.366 5.948 6.565 5.107 2.192-.841 9.658-3.703 12.515-4.797 2.854-1.095 3.537-3.658 2.664-5.68-.943-2.18-4.801-2.82-5.9-5.362-1.102-2.545-4.698-10.694-5.733-13.263-1.407-3.494 1.58-6.336 5.921-6.79 29.873-3.137 35.457 15.445 45.628 11.28 7.871-3.223 6.27-26.189-3.396-48.843"
            fill="#95a0b1" fill-rule="evenodd"/>
        </svg>
      </a>
    </li>

    <li class="dashboard-message" *ngIf="!isDisableInboxPage">
      <a class="sidebar-icon"
         placement="right" ngbTooltip="{{'info_box.inbox.sidebar' | translate}}"
         [routerLink]="['/dashboard/inbox']" [routerLinkActive]="['active']">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 27">
          <path
            d="M17.046 12.189L3.67 3.963h26.752zm13.376 11.517H3.67V7.253l13.376 8.227 13.376-8.227zm0-23.034H3.67C1.83.672.342 2.152.342 3.962L.325 23.707c0 1.81 1.505 3.29 3.345 3.29h26.752c1.84 0 3.344-1.48 3.344-3.29V3.963c0-1.81-1.505-3.29-3.344-3.29z"
            fill="#95a0b1" fill-rule="evenodd"/>
        </svg>
      </a>
    </li>

  </ul>

  <ul class="bottom">
    <li class='hidden-section'>
      <img class="user-avatar" src="assets/images/sidebar/settings.svg" alt=""/>
    </li>
    <li>
      <a [popper]="userNavigationPopper"
         [popperTrigger]="'click'"
         [popperHideOnClickOutside]="true"
         (popperOnShown)="popperOnShown($event)"
         (popperOnHidden)="popperOnHidden($event)"
         [popperDisableAnimation]="false"
         [popperApplyClass]="'ngx-popper, white'"
         [popperApplyArrowClass]="'ngx-popper-arrow'"
         [popperPlacement]="'right-end'">
        <div class="helper"><img class="user-avatar" src="{{userAvatarImage}}" alt=""/></div>
      </a>
      <popper-content #userNavigationPopper>
        <ul class="user-menu">
          <li class="header">{{'user.menu.user_navigation' | translate}}</li>
          <li [routerLink]="['/dashboard/settings']">{{'user.menu.user_settings' | translate}}</li>
          <li class="hidden-section">{{'user.menu.social_accounts' | translate}}</li>
          <li (click)="logout()">{{'user.menu.log_out' | translate}}</li>
        </ul>
      </popper-content>
    </li>
  </ul>
</div>

<achoo-popup #TermsAndConditionAccept
             [acceptBtnLabel]="'common.btn.accept' | translate"
             [isTermAndCondPopup]="true"
             (acceptCallback)="acceptTermAndCondition(newUser)">
  <div class="term-service">
    <h2 class="term-title">{{'common.terms_and_conditions' | translate}}</h2>
    <form class="sign-up-form" novalidate (ngSubmit)="acceptTermAndCondition(newUser)" [formGroup]="newUser">
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input"
               [formControlName]="'acceptTermService'"
               name="acceptTermService"
               type="checkbox">
        <label class="custom-control-label">
          <span class="static-text">{{'common.read_terms_and_conditions' | translate}}</span>
          <a href="https://www.getachoo.com/terms-of-service" target="_blank" class="term-service-link">{{'common.terms_and_conditions_1' | translate}}</a>
          <span class="link-text">{{'common.link_between_term_and_cond' | translate}}</span>
          <a href="https://www.getachoo.com/privacy-policy" target="_blank" class="term-service-link">{{'common.privacy_policy' | translate}}</a>
        </label>
      </div>
    </form>
  </div>
</achoo-popup>
<achoo-popup #InfluencerConfirmation [isSpecialPopup]="true">
  <influencer-confirmation (acceptCallback)="onAcceptTheConfirmation()"
                           (errorCallback)="onConfirmInfluencerInfoError()"></influencer-confirmation>
</achoo-popup>




// WEBPACK FOOTER //
// ./src/app/influencer-main/influencer-main.component.html